export const DEVICE_SEARCH_STATE_INITIAL = 'DEVICE_SEARCH_STATE_INITIAL';
export const DEVICE_SEARCH_STATE_NO_DEVICE_FOUND =
  'DEVICE_SEARCH_STATE_NO_DEVICE_FOUND';
